import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token'

const Cu = 'cu'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(Cu)
  window.sessionStorage.setItem('AuthorityStatusS', '')
  return Cookies.remove(TokenKey)
}

export function getUser() {
  return Cookies.get(Cu)
}

export function setUser(uname) {
  return Cookies.set(Cu, uname)
}

export function setUserID(UserID) {
  return Cookies.set('UserID', UserID)
}

export function getUserID() {
  return Cookies.get('UserID')
}
export function getParameterValue(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r1 = window.location.search.substr(1).match(reg)
  var r2 = null
  if (window.location.href.indexOf('?') > -1) {
    const arr = window.location.href.split('?')
    r2 = arr[1].match(reg)
  }
  if (r1 != null) {
    return unescape(r1[2])
  } else if (r2 != null) {
    return unescape(r2[2])
  } else {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js